module.exports = __webpack_public_path__ + "static/media/mama-burger-dt-fr.e176f0b9.jpg";